export default __webpack_public_path__ + "static/pell-e428cf37e5c79ad490cb9bb3f1142fa6.svg";